import React from 'react';
import { connect } from 'react-redux';
import { List, ListCheckbox } from 'react-toolbox/lib/list';
import moment from 'moment';

import { orderByStatus } from '~/actions/orders';
import Spinner from '~/components/Spinner';
import dynamicSort from '~/utils/dynamicSort';

import Styles from './order.scss';

class BatchPrintView extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { activePrint: {} };
  }
  componentDidMount() {
    // add check if is loaded
    if (this.props.tabData === false) {
      orderByStatus(this.props.dispatch, this.context.apiClient, this.props.name);
    }
  }
  componentWillReceiveProps(nextProps) {
    const { tabData } = nextProps;
    if (tabData) {
      const tabDataJs = tabData.toJS();
      const activePrint = { ...this.state.activePrint };
      tabDataJs.orders.forEach(item => {
        activePrint[item.shopId] =
          typeof activePrint[item.shopId] === 'undefined' || activePrint[item.shopId];
      });
      this.updateActivePrint(activePrint);
    }
  }

  selectAll(select = true) {
    this.updateActivePrint(
      Object.keys(this.state.activePrint).reduce((s, v) => ({ ...s, [v]: select }), {})
    );
  }

  updateActivePrint(activePrint) {
    this.setState({ activePrint }, () => {
      const orders = this.props.tabData.toJS().orders.filter(o => activePrint[o.shopId]);
      orders.sort(dynamicSort(this.props.orderBy));
      const shopIds = orders.map(o => o.shopId);
      this.props.setBatchPrintList(shopIds);
    });
  }

  render() {
    const { tabData } = this.props;
    if (!tabData) {
      return (
        <div className={Styles.orderContent}>
          <Spinner />
        </div>
      );
    }
    const tabDataJs = tabData.toJS();
    tabDataJs.orders.sort(dynamicSort(this.props.orderBy));
    const orders = tabDataJs.orders.map(item => {
      return (
        <ListCheckbox
          key={item.orderId}
          caption={item.invoiceId}
          checked={this.state.activePrint[item.shopId]}
          legend={`Created: ${moment(item.createdAt).format('LLL')}`}
          onChange={() => {
            const { activePrint } = this.state;
            activePrint[item.shopId] = !activePrint[item.shopId];
            this.updateActivePrint(activePrint);
          }}
        />
      );
    });
    return (
      <div>
        <List>
          <ListCheckbox
            legend="Select orders to print"
            onChange={state => this.selectAll(state)}
            checked={Object.values(this.state.activePrint).filter(v => v === false).length === 0}
          />
          {orders}
        </List>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    tabData: state.getIn(['orders', 'tabData', ownProps.name], false)
  };
};

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(BatchPrintView);



// WEBPACK FOOTER //
// ./app/pages/Orders/batchPrintView.js